export const ENVIRONMENT = `${import.meta.env.VITE_ENVIRONMENT}`;
export const SENTRY_DSN = `${import.meta.env.VITE_SENTRY_DSN}`;
